import React from 'react';
import { Hero } from './components/Hero';
import { Diagnosis } from './components/Diagnosis';
import { Mechanism } from './components/Mechanism';
import { Deliverables } from './components/Deliverables';
import { Audience } from './components/Audience';
import { HowItWorks } from './components/HowItWorks';
import { Vision } from './components/Vision';
import { Faq } from './components/Faq';
import { Offer } from './components/Offer';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-full bg-cream" data-id="element-0" data-mp="2mmvkstkfeeb0">
      <Hero data-id="element-1" data-mp="2mjzm330r7lli" />
      <main data-id="element-2" data-mp="31aqf2ee30qq7">
        <Diagnosis data-id="element-3" data-mp="31b8j3x6zk98o" />
        <Mechanism data-id="element-4" data-mp="31bs1ff0jszn8" />
        <Deliverables data-id="element-5" data-mp="31c9tdzg6grpc" />
        <Audience data-id="element-6" data-mp="31cjmvx0flgzs" />
        <HowItWorks data-id="element-7" data-mp="2wka0us2ft12s" />
        <Vision data-id="element-8" data-mp="2wjqgl4pbe0ll" />
        <Faq data-id="element-9" data-mp="2wj8dbo48im46" />
        <Offer data-id="element-10" data-mp="2wifc12o1ootf" />
      </main>
      <Footer data-id="element-11" data-mp="2wi5pxq64f1t0" />
    </div>;
}